























import { Component, Prop, Vue } from "vue-property-decorator";

interface IScalerItemDatas {
  image: string;
  title?: string;
  content?: string;
  href?: string;
  base?: string;
}

@Component
export default class iScalerItem extends Vue {
  @Prop({
    default: true
  })
  type?: string;

  @Prop({
    default: true
  })
  datas?: IScalerItemDatas;

  private article_show = false;

  public hide(container: iScalerItem) {
    if (this.type === "image" || this.type === "website") {
      // const image = container.$el.querySelector(
      //   ".lazy-image"
      // ) as HTMLImageElement;
      // // image!.style.backgroundSize = "cover";
    } else if (this.type === "article") {
      this.article_show = false;
      const inner = container.$el.querySelector(
        ".scaler-article-inner"
      ) as HTMLImageElement;
      inner!.style.cssText = "";
    }
  }

  public show(container: iScalerItem) {
    if (this.type === "image" || this.type === "website") {
      // const image = container.$el.querySelector(
      //   ".lazy-image"
      // ) as HTMLImageElement;
      // image!.style.backgroundSize = "contain";
    } else if (this.type === "article") {
      this.article_show = true;
      const inner = container.$el.querySelector(
        ".scaler-article-inner"
      ) as HTMLImageElement;
      const header = container.$el.querySelector(
        ".article-header"
      ) as HTMLImageElement;
      inner!.style.cssText = "overflow: overlay";
      header!.style.cssText = "height: 50vh; font-size: var(--font-size-large)";
    }
  }
}
